import React from 'react';
import { useI18n } from '../i18n';
import { Link } from '../router/Link';
import { useRouter } from '../router/RouterContext';

export function Footer() {
  const { t } = useI18n();
  const { path } = useRouter();
  const isRanna = path.startsWith('/rana');

  if (isRanna) {
    return (
      <footer style={{ borderTop: '1px solid var(--stroke)', background: 'var(--bg)' }}>
        <div
          style={{
            maxWidth: '72rem',
            margin: '0 auto',
            padding: '1.75rem 1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1rem',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
            <span aria-hidden style={{ display: 'flex', gap: '3px' }}>
              <span style={{ width: 7, height: 7, borderRadius: '50%', display: 'inline-block', background: '#4A7FB7', boxShadow: '0 0 5px #4A7FB7' }} />
              <span style={{ width: 7, height: 7, borderRadius: '50%', display: 'inline-block', background: '#FFC843', boxShadow: '0 0 5px #FFC843' }} />
            </span>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: '0.95rem', letterSpacing: '0.1em', color: 'var(--text)' }}>
              RANNA
            </span>
            <span style={{ fontSize: '0.65rem', color: 'var(--muted)', opacity: 0.5, marginLeft: '0.5rem' }}>
              Fan-made · BanG Dream! It's MyGO!!!!!
            </span>
          </div>
          <p style={{ fontSize: '0.6rem', color: 'var(--muted)', opacity: 0.3, margin: 0 }}>
            {t('footer.disclaimer')} · © Craft Egg / Bushiroad
          </p>
        </div>
      </footer>
    );
  }

  const muted: React.CSSProperties = { fontSize: '0.65rem', color: 'var(--muted)', opacity: 0.55, lineHeight: 1.8 };
  const divider = <span aria-hidden style={{ opacity: 0.3 }}> | </span>;

  return (
    <footer style={{ borderTop: '1px solid var(--stroke)', background: 'var(--bg)' }}>
      <div style={{ maxWidth: '72rem', margin: '0 auto', padding: '1.75rem 1.5rem' }}>
        {/* Legal links row */}
        <nav aria-label="법무 문서" style={{ marginBottom: '0.75rem' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.1rem', alignItems: 'center' }}>
            {[
              { to: '/legal?doc=terms', label: '서비스 이용약관' },
              { to: '/legal?doc=privacy', label: '개인정보 처리방침' },
              { to: '/legal?doc=community', label: '커뮤니티 이용규칙' },
              { to: '/legal?doc=location', label: '위치기반서비스 이용약관' },
              { to: '/delete-account', label: '계정·데이터 삭제 요청' },
            ].map((link, i, arr) => (
              <span key={link.to} style={{ display: 'inline-flex', alignItems: 'center' }}>
                <Link
                  to={link.to}
                  style={{ fontSize: '0.65rem', color: 'var(--muted)', opacity: 0.7, textDecoration: 'none', fontWeight: 600 }}
                >
                  {link.label}
                </Link>
                {i < arr.length - 1 && divider}
              </span>
            ))}
          </div>
        </nav>

        {/* Business info */}
        <p style={{ ...muted, margin: '0 0 0.1rem' }}>
          상호: 노라네코 (Noraneko){divider}대표자: 손호영{divider}사업자등록번호: 842-24-02387
        </p>
        <p style={{ ...muted, margin: '0 0 0.1rem' }}>
          서비스 문의: support@noraneko.cc{divider}개발자 연락: me@pyrimidines.org
        </p>
        <p style={{ ...muted, margin: '0.5rem 0 0' }}>
          © 2026 noraneko studio
        </p>
      </div>
    </footer>
  );
}
